import {NgModule} from '@angular/core';
import {IconComponent} from './icon/icon.component';
import {MenuIconComponent} from './icon/menu-icon/menu-icon.component';
import {HelpIconComponent} from './icon/help-icon/help-icon.component';
import {AccountIconComponent} from './icon/account-icon/account-icon.component';
import {BriefcaseIconComponent} from './icon/briefcase-icon/briefcase-icon.component';
import {SettingsIconComponent} from './icon/settings-icon/settings-icon.component';
import {ChevronIconComponent} from './icon/chevron-icon/chevron-icon.component';
import {PhoneLaptopIconComponent} from './icon/phone-laptop-icon/phone-laptop-icon.component';
import {EqualizerIconComponent} from './icon/equalizer-icon/equalizer-icon.component';
import {CommonModule} from '@angular/common';
import {PeopleIconComponent} from './icon/people-icon/people-icon.component';
import {BeenHereIconComponent} from './icon/been-here-icon/been-here-icon.component';
import {TimerIconComponent} from './icon/timer-icon/timer-icon.component';
import {SecurityIconComponent} from './icon/security-icon/security-icon.component';
import {ReportIconComponent} from './icon/report-icon/report-icon.component';
import {BallotIconComponent} from './icon/ballot-icon/ballot-icon.component';
import {ContactsIconComponent} from './icon/contacts-icon/contacts-icon.component';
import {BusinessIconComponent} from './icon/business-icon/business-icon.component';
import {MessageIconComponent} from './icon/message-icon/message-icon.component';
import {CloseIconComponent} from './icon/close-icon/close-icon.component';
import {DeleteIconComponent} from './icon/delete-icon/delete-icon.component';
import {NumberedListIconComponent} from './icon/numbered-list-icon/numbered-list-icon.component';
import {RemoveIconComponent} from './icon/remove-icon/remove-icon.component';
import {SearchIconComponent} from './icon/search-icon/search-icon.component';
import {AddIconComponent} from './icon/add-icon/add-icon.component';
import {ValidIconComponent} from './icon/valid-icon/valid-icon.component';
import {InvalidIconComponent} from './icon/invalid-icon/invalid-icon.component';
import {RefreshIconComponent} from './icon/refresh-icon/refresh-icon.component';
import {UploadIconComponent} from './icon/upload-icon/upload-icon.component';
import {SortIconComponent} from './icon/sort-icon/sort-icon.component';
import {FilterIconComponent} from './icon/filter-icon/filter-icon.component';
import {EditIconComponent} from './icon/edit-icon/edit-icon.component';
import {TagIconComponent} from './icon/tag-icon/tag-icon.component';
import { BellIconComponent } from './icon/bell-icon/bell-icon.component';
import {DirectionIconComponent} from './icon/direction-icon/direction-icon.component';
import { MobileIconComponent } from './icon/mobile-icon/mobile-icon.component';
import { TabletIconComponent } from './icon/tablet-icon/tablet-icon.component';
import { LaptopIconComponent } from './icon/laptop-icon/laptop-icon.component';
import { DesktopIconComponent } from './icon/desktop-icon/desktop-icon.component';

@NgModule({
    declarations: [
        AccountIconComponent,
        AddIconComponent,
        BallotIconComponent,
        BellIconComponent,
        BeenHereIconComponent,
        BriefcaseIconComponent,
        BusinessIconComponent,
        ChevronIconComponent,
        CloseIconComponent,
        ContactsIconComponent,
        DeleteIconComponent,
        DesktopIconComponent,
        DirectionIconComponent,
        EditIconComponent,
        EqualizerIconComponent,
        FilterIconComponent,
        HelpIconComponent,
        IconComponent,
        InvalidIconComponent,
        LaptopIconComponent,
        MenuIconComponent,
        MessageIconComponent,
        MobileIconComponent,
        NumberedListIconComponent,
        PeopleIconComponent,
        PhoneLaptopIconComponent,
        RefreshIconComponent,
        RemoveIconComponent,
        ReportIconComponent,
        SearchIconComponent,
        SecurityIconComponent,
        SettingsIconComponent,
        SortIconComponent,
        TabletIconComponent,
        TagIconComponent,
        TimerIconComponent,
        UploadIconComponent,
        ValidIconComponent
    ],
    entryComponents: [
        IconComponent
    ],
    exports: [
        AccountIconComponent,
        AddIconComponent,
        BallotIconComponent,
        BellIconComponent,
        BeenHereIconComponent,
        BriefcaseIconComponent,
        BusinessIconComponent,
        ChevronIconComponent,
        CloseIconComponent,
        ContactsIconComponent,
        DeleteIconComponent,
        DesktopIconComponent,
        DirectionIconComponent,
        EditIconComponent,
        EqualizerIconComponent,
        FilterIconComponent,
        HelpIconComponent,
        IconComponent,
        InvalidIconComponent,
        LaptopIconComponent,
        MenuIconComponent,
        MessageIconComponent,
        MobileIconComponent,
        NumberedListIconComponent,
        PeopleIconComponent,
        PhoneLaptopIconComponent,
        RefreshIconComponent,
        RemoveIconComponent,
        ReportIconComponent,
        SearchIconComponent,
        SecurityIconComponent,
        SettingsIconComponent,
        SortIconComponent,
        TabletIconComponent,
        TagIconComponent,
        TimerIconComponent,
        UploadIconComponent,
        ValidIconComponent
    ],
    imports: [
        CommonModule
    ]
})
export class IconsModule {
}
